export const SOFTLINE_API_ITEM_SCAN = 'v1/items/scan/{labelType}/{data}';

export const SOFTLINE_API_FIELDOK_ARTSTAMM_QUERY = '/v1/bean/query/artstamm';
export const SOFTLINE_API_FIELDOK_ARTSTAMM_RESULT = '/v1/bean/abfrageResult/artstamm/{{id}}';

export const SOFTLINE_API_FIELDOK_KOPFAU_QUERY = '/v1/bean/query/kopfau';
export const SOFTLINE_API_FIELDOK_KOPFAU_RESULT = '/v1/bean/abfrageResult/kopfau/{{id}}';

export const SOFTLINE_API_ORDER_DETAILS = 'v1/feichtinger/wiegen/auftrag/{id}/{type}';
export const SOFTLINE_API_WEIGHT = 'v1/feichtinger/wiegen/wiegen';

export const SOFTLINE_API_WEIGHT_NEW = 'v1/feichtinger/wiegen/wiegen/waage/{{id}}';
export const SOFTLINE_API_WIEGUNG_BELEGE_SCAN = '/v1/belege/scan/{{labelType}}/{{code}}';
export const SOFTLINE_API_WIEGUNG_GOLDSCHMIEDE_MATERIALS = 'v1/feichtinger/goldschmiede/kopfau/entities/{{idkopfau}}/beweau/entites';
export const SOFTLINE_API_WEIGHT_GET_UNITS = 'v1/feichtinger/wiegen/einheiten/{{id}}';

export const SOFTLINE_API_WEIGHT_EXTRA_MATERIALS = 'v1/feichtinger/wiegen/gewichtsartikel';
export const SOFTLINE_API_WEIGHT_LIGHT_MATERIALS = 'v1/feichtinger/wiegen/legierung/{{idkopfau}}';
